// extracted by mini-css-extract-plugin
export default {"image-upload":"Company_image-upload__1ERvR","react-pdf__Page__canvas":"Company_react-pdf__Page__canvas__+cPpJ"};